/** Base file entity class. */
export abstract class CloudFile {
  abstract getFullPath(): string;
  abstract getName(): string;
  abstract delete(): Promise<boolean>;
  abstract download(): Promise<Blob>;
  abstract upload(file: Blob): Promise<boolean>;
}
